import React from 'react';
import Slider from "react-slick";

const Carousel = ({device}) => {
    const settings = {
        autoplay: true,
        autopalySpeed: 2000,
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows:false,
        pauseOnHover: true
      };
      return device === "pc" ? (
        <Slider {...settings}>
          <div>
            <img className="imgs" src="/img/pages/pc-slide-6.jpg" />
          </div>
          <div>
            <img className="imgs" src="/img/pages/pc-slide-4-new.jpg" />
          </div>
          <div>
            <img className="imgs" src="/img/pages/pc-slide-0.png" />
          </div>
          <div>
            <img className="imgs" src="/img/pages/pc-slide-7.jpg" />
          </div>



        </Slider>
      ) : (
        <Slider {...settings}>
          <div>
            <img className="imgs" src="/img/pages/mobile-slide-6.jpg " />
          </div>
          <div>
            <img className="imgs" src="/img/pages/mobile-slide-4-new.jpg " />
          </div>
          <div>
            <img className="imgs" src="/img/pages/mobile-slide-0.jpg " />
          </div>
          <div>
            <img className="imgs" src="/img/pages/mobile-slide-7.jpg" />
          </div>



        </Slider>
      );
};

export default Carousel;